export const emailTypes = [
    { label: 'Brandscore', value: 'brandscore' },
    { label: 'Marketshare', value: 'marketshare' },
    { label: 'Distribution', value: 'distribution' },
];
